module.exports = __webpack_public_path__ + "img/financeiro.05feca51.svg";